module.exports = __webpack_public_path__ + "static/churchill-e1c0e716d973fc3add7a39f4a8f93e86.jpg";